import React from 'react';
import { Branding, Copyright } from './Layout';

const LoginEmail = ({ email, setEmail, otp, setOtp, otpSent, loading, handleRequestOTP, handleVerifyOTP, loginMode, setLoginMode, setOtpSent, isForcedEmail }) => {
    const onSubmit = (e) => {
        e.preventDefault();
        if (otpSent) handleVerifyOTP(otp);
        else handleRequestOTP(email);
    };

    return (
        <div className="card glass-premium border-0 p-5 text-center fade-in-up mx-auto" style={{ maxWidth: '450px', borderRadius: '45px' }}>
            <Branding />

            <p className="text-muted fw-600 mt-4 mb-4 small px-2" style={{ lineHeight: '1.4' }}>
                Per registrarti o entrare in Solteros inserisci la tua email.
                {!isForcedEmail && (
                    <>
                        <br />
                        Per partecipare al gioco inserisci il codice che ti è stato fornito.
                    </>
                )}
            </p>

            {/* Toggle Buttons inside the Login Card */}
            {!isForcedEmail && (
                <div className="d-flex bg-white bg-opacity-50 p-1 rounded-pill mb-4 shadow-inner" style={{ border: '1px solid rgba(219,39,119,0.1)' }}>
                    <button
                        className={`btn btn-sm flex-grow-1 rounded-pill fw-700 py-2 transition-all ${loginMode === 'token' ? 'bg-white shadow-sm text-pink-600' : 'text-muted border-0'}`}
                        onClick={() => { setLoginMode('token'); if (setOtpSent) setOtpSent(false); }}
                    >
                        CODICE GIOCO
                    </button>
                    <button
                        className={`btn btn-sm flex-grow-1 rounded-pill fw-700 py-2 transition-all ${loginMode === 'email' ? 'bg-white shadow-sm text-pink-600' : 'text-muted border-0'}`}
                        onClick={() => setLoginMode('email')}
                    >
                        EMAIL
                    </button>
                </div>
            )}

            <form onSubmit={onSubmit}>
                <div className="mb-4 text-start">
                    <label className="form-label small fw-900 text-muted text-uppercase ls-lg ms-3">Tua Email</label>
                    <input
                        type="email"
                        className="form-control form-control-lg form-control-premium px-4"
                        placeholder="tua@email.com"
                        style={{ height: '65px' }}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        disabled={otpSent}
                    />
                </div>
                {otpSent && (
                    <div className="mb-4 text-start">
                        <label className="form-label small fw-900 text-muted text-uppercase ls-lg ms-3">Codice TEMPORANEO</label>
                        <input
                            type="text"
                            className="form-control form-control-lg text-center fw-900 form-control-premium"
                            placeholder="000000"
                            style={{ height: '65px', letterSpacing: '5px' }}
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            required
                        />
                    </div>
                )}
                <button
                    type="submit"
                    className="btn btn-lg w-100 py-3 shadow-lg fw-900 text-white"
                    style={{ borderRadius: '25px', background: 'linear-gradient(45deg, #db2777, #f43f5e)', border: 'none', height: '65px' }}
                    disabled={loading}
                >
                    {loading ? <i className="fas fa-spinner fa-spin"></i> : (otpSent ? 'VERIFICA' : 'INVIA CODICE TEMPORANEO')}
                </button>
                {otpSent && !loading && (
                    <button
                        type="button"
                        className="btn btn-link mt-3 text-muted fw-700 text-decoration-none"
                        onClick={() => setOtpSent(false)}
                    >
                        <i className="fas fa-arrow-left me-2"></i> Cambia Email
                    </button>
                )}
            </form>
            <Copyright />
        </div>
    );
};

export default LoginEmail;
